<!-- Page Header End -->
<app-pageheader [pageOptions]="pageOptions"></app-pageheader>
<!-- Page Header End -->

<!-- Page content start -->
<div class="container-xxl py-5 wow fadeInUp" data-wow-delay="0.1s">
  <div class="container">
    <!-- Scout content start -->
    <div id="SCOUT_SECTION">
      <h1 class="mb-4">{{ "scouts" | translate }}</h1>
      <app-articles-view
        [articles]="scoutsArticlesArray"
        [itemsPerPage]="scoutsLimit"
        [totalcount] ="scoutsTotalcount"
        [articleSection] = "'SCOUT_SECTION'"
        (onPaginateEvent) = "onScoutPaginateEvent($event)"
      ></app-articles-view>
    </div>
    <!-- Scout content end -->

    <!-- Mej content start -->
    <div id="MEJ_SECTION">
      <h1 class="mb-4">{{ "mej" | translate }}</h1>
      <app-articles-view
        [articles]="mejArticlesArray"
        [itemsPerPage]="mejLimit"
        [totalcount] ="mejTotalcount"
        [articleSection] = "'MEJ_SECTION'"
        (onPaginateEvent) = "onMejPaginateEvent($event)"
      ></app-articles-view>
    </div>
    <!-- Mej content end -->
  </div>
</div>
<!-- Page content end -->
